var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from "react";
import deleteServiceMutation from "./delete-service.mutation.graphql";
import { withRouter } from "react-router-dom";
import { ButtonModal, TextField, withShowFlag, getErrorMessage, withAnalytics, compose, graphql } from "@atlassiansox/microscopekit";
var DeleteServiceModalView = /** @class */ (function (_super) {
    __extends(DeleteServiceModalView, _super);
    function DeleteServiceModalView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.deleteService = function () { return __awaiter(_this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.props.deleteService({
                                variables: {
                                    id: this.props.id
                                }
                            })];
                    case 1:
                        _a.sent();
                        this.props.track("Overview.DeleteServiceModal: Delete", {
                            category: "info"
                        });
                        this.props.showFlag({
                            type: "success",
                            title: "Success",
                            message: "Service has been queued for deletion. This may take a while."
                        });
                        this.props.history.push("/");
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        this.props.track("Overview.DeleteServiceModal: DeleteFailed", {
                            category: "error"
                        });
                        this.props.showFlag({
                            type: "error",
                            title: "Delete service failed.",
                            message: getErrorMessage(error_1)
                        });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    DeleteServiceModalView.prototype.render = function () {
        var _this = this;
        return (React.createElement(ButtonModal, { buttonText: "Delete Service", heading: "Delete Service", actions: {
                submit: {
                    text: "Delete",
                    onSubmit: this.deleteService
                },
                close: {
                    text: "Close"
                }
            } },
            "Please type the name of your service below to delete it.",
            React.createElement("br", null),
            React.createElement("strong", null, "Caution: You will not be able to reverse this action."),
            React.createElement(TextField, { name: "serviceName", label: "Enter service name", isRequired: true, validate: function (value) {
                    return value === _this.props.id
                        ? Promise.resolve()
                        : Promise.resolve("Must enter service name");
                }, message: function (_a) {
                    var error = _a.error;
                    return error;
                } })));
    };
    return DeleteServiceModalView;
}(React.Component));
export { DeleteServiceModalView };
export var DeleteServiceModal = compose(graphql(deleteServiceMutation, {
    name: "deleteService"
}), withShowFlag, withRouter, withAnalytics)(DeleteServiceModalView);
